//推广

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 推广状态枚举
 */
class State extends UltMeta {
    EFFECTIVE = new Meta(1, "有效");
    OVERDUE = new Meta(2, "过期");
    CLOSED = new Meta(3, "关闭");
}

export const STATE = new State();

/**
 * 是否赠送会员枚举
 */
class HasGift extends UltMeta {
    YES = new Meta(1, "是", "01");
    NO = new Meta(2, "否", "02");
}

export const HAS_GIFT = new HasGift();

/**
 * 是否付费
 */
class HasPaid extends UltMeta {
    YES = new Meta(1, "是");
    NO = new Meta(2, "否");
}

export const HAS_PAID = new HasPaid();
